module.exports = __webpack_public_path__ + "img/3_04.43f916fe.jpg";